<div class="width-1 spacer" [ngStyle]="{ height: height + 'px' }"></div>

<div #buttonWrapper class="button-wrapper" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="end center">
    <ng-content></ng-content>
</div>
